import * as React from 'react';
import * as classNames from 'classnames';
import { observer, inject } from 'mobx-react';
import { formatMoney, formatNumber } from 'accounting';
import { IAppOnlyStore } from '../../stores';
import { LoadingSpinner, StatusIcon, EStatusIconType } from '../../components/indicator';
import { IShippingListEntryValidation, EShippingListEntryStatus } from '../../../../common/interfaces/shippingList';
import AnimateHeight from 'react-animate-height';

// Styles
const s = require('./ShippingListUploadValidation.css');

// Component
@inject('store')
@observer
export class ShippingListUploadValidation extends React.Component<IAppOnlyStore, {}> {
    render() {
        const { shippingListUpload } = this.props.store;

        return (
            <div className={s.content}>
                <AnimateHeight className={s.loader} height={shippingListUpload.uploadingCsvFile ? 'auto' : 0}>
                    <LoadingSpinner active={shippingListUpload.uploadingCsvFile} />
                </AnimateHeight>

                {shippingListUpload.shippingListId !== null &&
                    shippingListUpload.shippingListData &&
                    shippingListUpload.shippingListData.length > 0 && (
                        <table>
                            <thead>
                                <tr>
                                    <th className="text-align-left">Item code</th>
                                    <th className="text-align-right">Quantity</th>
                                    <th className="text-align-right">Price</th>
                                    <th className="text-align-right" />
                                </tr>
                            </thead>
                            <tbody>
                                {shippingListUpload.shippingListDataFiltered.map((entry, entryIndex) => {
                                    return (
                                        <tr key={entry.itemcode + '-' + entryIndex}>
                                            <td className="text-align-left">
                                                <p className={classNames(s.itemcode, { [s.error]: !entry.isValid })}>
                                                    {entry.itemcode}
                                                </p>
                                            </td>

                                            <td className="text-align-right">
                                                <p
                                                    className={classNames(s.validation, {
                                                        [s.error]: entry.status === EShippingListEntryStatus.Invalid
                                                    })}
                                                >
                                                    <span>Shipment quantity:</span>
                                                    <strong>{formatNumber(entry.quantity, 0)}</strong>
                                                </p>
                                                <p
                                                    className={classNames(s.validation, {
                                                        [s.error]: entry.status === EShippingListEntryStatus.Invalid
                                                    })}
                                                >
                                                    <span>Open quantity:</span>
                                                    <strong>{formatNumber(entry.totalAllocated, 0)}</strong>
                                                </p>
                                            </td>

                                            <td className="text-align-right">
                                                <p
                                                    className={classNames(s.validation, {
                                                        [s.highlight]:
                                                            entry.status === EShippingListEntryStatus.ValidWithDifferentPrices,
                                                        [s.error]:
                                                            entry.status === EShippingListEntryStatus.DuplicateItemsPriceInvalid
                                                    })}
                                                >
                                                    <span>Uploaded price:</span>
                                                    <strong>{formatMoney(entry.price, '$', 2)}</strong>
                                                </p>
                                                <p
                                                    className={classNames(s.validation, {
                                                        [s.highlight]:
                                                            entry.status === EShippingListEntryStatus.ValidWithDifferentPrices,
                                                        [s.error]:
                                                            entry.status === EShippingListEntryStatus.DuplicateItemsPriceInvalid
                                                    })}
                                                >
                                                    <span>List price:</span>
                                                    <strong>{formatMoney(entry.poPrice, '$', 2)}</strong>
                                                </p>
                                            </td>

                                            <td className="text-align-right">
                                                <StatusIcon
                                                    type={entry.isValid ? EStatusIconType.Success : EStatusIconType.Error}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}

                                {shippingListUpload.shippingListDataFiltered.length <= 0 && (
                                    <tr key="no-results">
                                        <td className="text-align-center" colSpan={4}>
                                            <p>
                                                {shippingListUpload.shippingListData.length > 0
                                                    ? 'No data matching filter criteria'
                                                    : 'No data uploaded in CSV'}
                                            </p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/internal/ShippingListUploadValidation.tsx